/*
 * ORA: tendine delle opzioni prodotto (snippets/ora-size-dropdown.liquid) e pannello guida taglie.
 * Delegazione sul documento, così continua a funzionare dopo i morph di Horizon.
 * Tastiera: frecce, Home, Fine, Invio, Spazio per scegliere, Esc per chiudere, Tab esce.
 */
(() => {
  if (window.oraSizeDropdown) return;
  window.oraSizeDropdown = true;

  const OPEN = 'ora-dd--open';
  const options = (dd) => Array.from(dd.querySelectorAll('[role="option"]'));
  const enabled = (li) => li.getAttribute('aria-disabled') !== 'true';

  function setActive(dd, li) {
    options(dd).forEach((o) => o.classList.toggle('is-active', o === li));
    const list = dd.querySelector('.ora-dd__list');
    if (li) {
      list.setAttribute('aria-activedescendant', li.id);
      li.scrollIntoView({ block: 'nearest' });
    } else {
      list.removeAttribute('aria-activedescendant');
    }
  }

  function move(dd, step) {
    const all = options(dd);
    if (!all.length) return;
    let i = all.findIndex((o) => o.classList.contains('is-active'));
    for (let n = 0; n < all.length; n++) {
      i = (i + step + all.length) % all.length;
      if (enabled(all[i])) return setActive(dd, all[i]);
    }
  }

  function close(dd, focusButton) {
    if (!dd || !dd.classList.contains(OPEN)) return;
    dd.classList.remove(OPEN);
    dd.querySelector('.ora-dd__btn')?.setAttribute('aria-expanded', 'false');
    setActive(dd, null);
    if (focusButton) dd.querySelector('.ora-dd__btn')?.focus({ preventScroll: true });
  }

  function closeAll(except) {
    document.querySelectorAll(`[data-ora-dd].${OPEN}`).forEach((dd) => dd !== except && close(dd, false));
  }

  function open(dd) {
    closeAll(dd);
    dd.classList.add(OPEN);
    dd.querySelector('.ora-dd__btn')?.setAttribute('aria-expanded', 'true');
    const selected = options(dd).find((o) => o.getAttribute('aria-selected') === 'true' && enabled(o));
    if (selected) setActive(dd, selected);
    else {
      setActive(dd, null);
      move(dd, 1);
    }
    dd.querySelector('.ora-dd__list')?.focus({ preventScroll: true });
  }

  /** Trova l'input o l'option del variant picker con lo stesso valore. */
  function findTarget(dd, valueId) {
    const own = dd.closest('fieldset')?.querySelector(`input[data-option-value-id="${valueId}"]`);
    if (own) return own;
    const productId = dd.dataset.productId;
    const scope = productId ? document.querySelector(`variant-picker[data-product-id="${productId}"]`) : null;
    return (scope || document).querySelector(
      `variant-picker [data-option-value-id="${valueId}"]`
    );
  }

  function pick(dd, li) {
    if (!li || !enabled(li)) return;
    const valueId = li.dataset.valueId;
    const label = li.textContent.trim();
    // aggiorna subito tutte le tendine della stessa opzione (pagina e barra fissa)
    document.querySelectorAll(`[data-ora-dd] [data-value-id="${valueId}"]`).forEach((match) => {
      const other = match.closest('[data-ora-dd]');
      options(other).forEach((o) => o.setAttribute('aria-selected', String(o === match)));
      const v = other.querySelector('.ora-dd__v');
      if (v) v.textContent = label;
    });
    close(dd, true);

    const target = findTarget(dd, valueId);
    if (target instanceof HTMLInputElement) {
      if (target.checked) return;
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (target instanceof HTMLOptionElement) {
      const select = target.closest('select');
      if (!select || select.value === target.value) return;
      select.value = target.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('click', (event) => {
    const t = /** @type {HTMLElement} */ (event.target);
    const btn = t.closest?.('.ora-dd__btn');
    if (btn) {
      const dd = btn.closest('[data-ora-dd]');
      dd.classList.contains(OPEN) ? close(dd, true) : open(dd);
      return;
    }
    const li = t.closest?.('[data-ora-dd] [role="option"]');
    if (li) {
      pick(li.closest('[data-ora-dd]'), li);
      return;
    }
    if (t.closest?.('[data-ora-guide-open]')) {
      const guide = t.closest('variant-picker')?.querySelector('[data-ora-guide]') || document.querySelector('[data-ora-guide]');
      if (guide instanceof HTMLDialogElement) guide.showModal();
      return;
    }
    if (t.closest?.('[data-ora-guide-close]')) {
      t.closest('dialog')?.close();
      return;
    }
    if (t instanceof HTMLDialogElement && t.matches('[data-ora-guide]')) t.close();
  });

  document.addEventListener('pointerdown', (event) => {
    const t = /** @type {HTMLElement} */ (event.target);
    if (!t.closest?.('[data-ora-dd]')) closeAll(null);
  });

  document.addEventListener('mousemove', (event) => {
    const li = /** @type {HTMLElement} */ (event.target).closest?.('[data-ora-dd] [role="option"]');
    if (li && enabled(li) && !li.classList.contains('is-active')) setActive(li.closest('[data-ora-dd]'), li);
  });

  document.addEventListener('keydown', (event) => {
    const t = /** @type {HTMLElement} */ (event.target);
    const dd = t.closest?.('[data-ora-dd]');
    if (!dd) {
      if (event.key === 'Escape') closeAll(null);
      return;
    }
    const isOpen = dd.classList.contains(OPEN);
    if (t.classList.contains('ora-dd__btn')) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        open(dd);
      } else if (event.key === 'Escape' && isOpen) {
        event.preventDefault();
        close(dd, true);
      }
      return;
    }
    if (!t.classList.contains('ora-dd__list')) return;
    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        move(dd, 1);
        break;
      case 'ArrowUp':
        event.preventDefault();
        move(dd, -1);
        break;
      case 'Home':
        event.preventDefault();
        setActive(dd, null);
        move(dd, 1);
        break;
      case 'End': {
        event.preventDefault();
        const all = options(dd).filter(enabled);
        setActive(dd, all[all.length - 1] || null);
        break;
      }
      case 'Enter':
      case ' ':
        event.preventDefault();
        pick(dd, dd.querySelector('[role="option"].is-active'));
        break;
      case 'Escape':
        event.preventDefault();
        event.stopPropagation();
        close(dd, true);
        break;
      case 'Tab':
        close(dd, false);
        break;
    }
  });
})();
